<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
    
    watch: {
      // Watch for theme state changes and update Vuetify
      '$store.state.theme.darkMode'(newValue) {
        this.$vuetify.theme.dark = newValue;
      }
    },
    
    mounted() {
      // Initialize theme on app mount
      this.$store.dispatch('theme/initializeTheme');
    }
  }
</script>
